export interface WebRequestContext {
  timezone_source: 'browser_intl';
  message_time_utc: string;
  sender_timezone?: string;
  sender_timezone_offset: string;
  sender_timezone_offset_seconds: number;
  sender_local_date: string;
  sender_local_time: string;
}

function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

export function formatTimezoneOffset(offsetSeconds: number): string {
  const sign = offsetSeconds >= 0 ? '+' : '-';
  const absoluteSeconds = Math.abs(offsetSeconds);
  const hours = Math.floor(absoluteSeconds / 3600);
  const minutes = Math.floor((absoluteSeconds % 3600) / 60);
  return `${sign}${pad2(hours)}:${pad2(minutes)}`;
}

export function buildWebRequestContext(now = new Date()): WebRequestContext {
  const offsetSeconds = -now.getTimezoneOffset() * 60;
  return {
    timezone_source: 'browser_intl',
    message_time_utc: now.toISOString(),
    sender_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || undefined,
    sender_timezone_offset: formatTimezoneOffset(offsetSeconds),
    sender_timezone_offset_seconds: offsetSeconds,
    sender_local_date: [
      now.getFullYear(),
      pad2(now.getMonth() + 1),
      pad2(now.getDate()),
    ].join('-'),
    sender_local_time: [
      pad2(now.getHours()),
      pad2(now.getMinutes()),
      pad2(now.getSeconds()),
    ].join(':'),
  };
}
